export default "__VITE_PUBLIC_ASSET__e0db314d__"